import {TopNavLogo} from './partials/top-nav-logo';
import {TopNavUpdate} from './partials/top-nav-update';
import {useRequesting} from '../../../../hooks/use-requesting';

import './scss/top-nav.scss';

interface props {
    /** the controls on the right: the station, language, theme and user of a logged in user */
    children?: React.ReactNode;
}

/**
 * The bar at the top of every page: the logo, the environment and the build on the left; a new version, and the
 * controls it is given, on the right. The login page shows it without controls. It is busy while the API is asked
 * something: a bar runs along its bottom edge then.
 */
const TopNav = ({children}: props): React.JSX.Element => {
    const requesting = useRequesting();

    return (
        <header className="top-bar" aria-busy={requesting}>
            <TopNavLogo />
            <TopNavUpdate />
            {children}
        </header>
    );
};

export default TopNav;
